import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { verifySenderPickup } from "../../../features/dashboard/newBuilderSlice";
import OtpModal from "../../auth/OTPModal";
import toast from "react-hot-toast";

const PickUpPage = () => {
  const dispatch = useDispatch();
  const { id: unique_code } = useParams();

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);

  useEffect(() => {
    setShowOtpModal(true);
  }, []);

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setOtpError("Enter valid 6-digit OTP");
      return;
    }

    try {
      setLoading(true);
      const result = await dispatch(
        verifySenderPickup({ unique_code, otp })
      ).unwrap();

      setOtpSuccess(true);
      setOtpError("");
      setResponseData(result);
      toast.success(result?.message || "Sender verified successfully!");
    } catch (error) {
      toast.error(error?.message || "Failed to verify OTP");
      setOtpError(error?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowOtpModal(false);
    window.location.href = "https://fetanmarket.com";
  };

  return (
    <div>
      {showOtpModal && (
        <OtpModal
          otp={otp}
          setOtp={setOtp}
          otpError={otpError}
          otpSucess={otpSuccess}
          setOtpError={setOtpError}
          onSubmit={handleVerifyOtp}
          onClose={handleCloseModal}
          title="Enter OTP"
          loading={loading}
          message={responseData?.message}
        />
      )}
    </div>
  );
};

export default PickUpPage;
